/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Sc_CloseInputs */

const en_mk_tut_sc_close = /** @type {(inputs: Mk_Tut_Sc_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close a dialog or cancel what you are typing`)
};

const id_mk_tut_sc_close = /** @type {(inputs: Mk_Tut_Sc_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutup dialog atau batalkan yang sedang diketik`)
};

/**
* | output |
* | --- |
* | "Close a dialog or cancel what you are typing" |
*
* @param {Mk_Tut_Sc_CloseInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_sc_close = /** @type {((inputs?: Mk_Tut_Sc_CloseInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Sc_CloseInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_sc_close(inputs)
	return en_mk_tut_sc_close(inputs)
});